import * as React from "react";
import { useEffect, useState } from "react";
import { HeaderSearchResults } from "../HeaderSearchResults";

export function TabbedLayout({
  settings,
  query,
  productsTotal,
  articlesTotal,
  handleCategoryClick,
  selectedCategory,
  isMobile,
  articles,
  products,
  showSeeAllProductsAtBottom,
}) {
  const showNavigationTabs = productsTotal > 0 || articlesTotal > 0;

  return (
    <>
      <div className="header-search__tabbed flex justify-between items-center">
        <div className="flex w-full lg:w-auto justify-between">
          <h2 className="text-sm lg:text-base font-medium">
            {selectedCategory === "products" ? "Product" : "Article"} Results ( {selectedCategory === "products" ? productsTotal : articlesTotal} )
          </h2>
          {isMobile && (
            <div
              className="lg:hidden cursor-pointer border-none px-2 text-[20px]"
              onClick={() => {
                if (window.Alpine && window.Alpine.store('global')) {
                  window.Alpine.store('global').toggleSearch();
                }
              }}
            >
              <span className="sr-only">Close</span>
              <i className="icon icon-x-thin"></i>
            </div>
          )}
        </div>
        <div className="hidden lg:flex gap-x-[8px] items-center">
          <a href={`/search?q=${query}&type=${selectedCategory === "products" ? "product" : "article"}`} className="b2 button-text flex items-center gap-2 hover:underline">
            <span>Show All {selectedCategory === "products" ? "Product" : "Article"} Results</span>
            <i className="icon icon-ur-arrow text-[19px]"></i>
          </a>
        </div>
      </div>

      {showNavigationTabs && (
        <div className="border-b border-gray-200 hidden lg:block">
          <nav className="flex">
            {productsTotal > 0 && (
              <button
                className={`text-sm py-3 px-6 cursor-pointer border-b-2 transition-colors duration-200 ${selectedCategory === "products" ? "border-black text-black font-medium" : "border-transparent text-gray-500"}`}
                onClick={() => handleCategoryClick("products")}
              >
                PRODUCTS ( {productsTotal} )
              </button>
            )}
            {articlesTotal > 0 && (
              <button
                className={`text-sm py-3 px-6 cursor-pointer border-b-2 transition-colors duration-200 ${selectedCategory === "articles" ? "border-black text-black font-medium" : "border-transparent text-gray-500"}`}
                onClick={() => handleCategoryClick("articles")}
              >
                ARTICLES ( {articlesTotal} )
              </button>
            )}
          </nav>
        </div>
      )}

      {selectedCategory === "products" && products && (
        <>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-2 lg:gap-x-5 gap-y-4 lg:gap-y-10 lg:overflow-y-auto pt-4 lg:pt-6">
            <HeaderSearchResults
              settings={settings}
              results={products}
              type={"products"}
            />
          </div>

          {isMobile && products.length > 0 && (
            <div className="flex justify-center gap-2 mt-4">
              <a
                href={`/search?q=${query}&type=product`}
                className="b3 button-text flex items-center gap-2"
              >
                <span className="hover:underline">Show All Product Results</span>
                <i className="icon icon-ur-arrow text-[19px]"></i>
              </a>
            </div>
          )}
        </>
      )}
      
      {selectedCategory === "articles" && articles && (
        <div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-x-2 lg:gap-x-5 gap-y-4 lg:gap-y-10 lg:overflow-y-auto pb-4 pt-4 lg:pt-6">
            <HeaderSearchResults
              settings={settings}
              results={articles}
              type={"articles"}
            />
          </div>
          
          {isMobile && articles.length > 0 && (
            <div className="flex justify-center gap-2 mt-4">
              <a
                href={`/search?q=${query}&type=article`}
                className="b3 button-text flex items-center gap-2"
              >
                <span className="hover:underline">Show All Article Results</span>
                <i className="icon icon-ur-arrow text-[19px]"></i>
              </a>
            </div>
          )}
        </div>
      )}
      
      {!isMobile &&
        showSeeAllProductsAtBottom &&
        selectedCategory === "products" &&
        products && (
          <div className="text-center mt-6 pt-4 border-t">
            <a
              href={`/search?q=${query}`}
              className="button btn-primary hover:no-underline"
            >
              SEE ALL RESULTS ({productsTotal + articlesTotal})
            </a>
          </div>
        )}
    </>
  );
}
